import {Box, Button, styled, TextField} from "@mui/material";
import ThemedText from "../text";
import {scale} from "../../utils";
import React from "react";
import theme, {FONTS} from "../../constants/theme";
import {DonorTypeFilter} from "../../types";

interface Props {
  textSearch: string;
  setTextSearch: (textSearch: string) => void;
  activeFilter: DonorTypeFilter;
  setActiveFilter: (filter: DonorTypeFilter) => void;
}

const Wrapper = styled(Box)({
  display: "flex",
  flexDirection: "row",
  width: scale(730),
  height: scale(50),
  alignItems: "baseline",
  gap: scale(15),
  marginBottom: scale(30),
})

const InputWrapper = styled(Box)({
  width: scale(400),
  height: scale(35),
  display: 'flex',
  rowGap: 2,
  flexDirection: 'column',
  flexBasis: '50%',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
  boxSizing: 'border-box',
});

const ButtonGroup = styled(Box)({
  display: "flex",
  gap: scale(10),
})

const ThemedButton = styled(Button)({
  borderRadius: scale(20),
  width: scale(83),
  height: scale(25),
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
});

const slotProps = {
  input: {
    sx: {
      fontFamily: FONTS.MONTSERRAT,
      fontWeight: 500,
      fontSize: scale(18),
      color: theme.palette.ceramic.contrastText,
      height: scale(40),
      width: scale(200),
      boxSizing: 'border-box',
      backgroundColor: 'transparent',
      borderRadius: 0,
      '& > input': {
        height: scale(40),
        paddingTop: scale(7),
        paddingLeft: scale(8),
        paddingBottom: scale(6),
        boxSizing: 'border-box',
      }
    },
  },
}

const inputRootStyle = {
  borderRadius: 0,
  '& .MuiInput-underline:before': {
    borderBottom: '1px solid',
    borderColor: theme.palette.primary.main,
  },
  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
    borderBottom: '1px solid',
    borderColor: theme.palette.primary.main,
  },
}

const DonorSearch = ({textSearch, setTextSearch, activeFilter, setActiveFilter}: Props) => {
  return (
    <Wrapper>
      <ThemedText
        fontSize={scale(18)}
        align={'center'}
        fontWeight={700}
        lineHeight={scale(66)}
        letterSpacing={scale(0)}
        text={'RICERCA'}
        color={theme.palette.ceramic.contrastText}
      />
      <InputWrapper>
        <TextField
          placeholder="Nome Cognome"
          variant="standard"
          color={'primary'}
          size={'small'}
          slotProps={slotProps}
          value={textSearch}
          onChange={(event) => setTextSearch(event.target.value)}
          onBlur={(event) => setTextSearch(event.target.value)}
          sx={inputRootStyle}
        />
      </InputWrapper>
      <ButtonGroup>
        {(['plasma & sangue', 'sangue', 'plasma'] as DonorTypeFilter[]).map((filterOption) => (
          <ThemedButton
            key={filterOption}
            type="button"
            variant="contained"
            onClick={() => setActiveFilter(filterOption)}
            sx={{
              backgroundColor: activeFilter === filterOption ? theme.palette.primary.main : theme.palette.light_blue.main,
              color: activeFilter === filterOption ? theme.palette.ceramic.contrastText : undefined,
            }}
          >
            <ThemedText text={filterOption === 'plasma & sangue' ? 'Tutte' : filterOption} fontWeight={600} fontSize={scale(12)} />
          </ThemedButton>
        ))}
      </ButtonGroup>
    </Wrapper>
  )
}

export default DonorSearch;
